import React from "react";

import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

import Button from "designV2/components/Button";
import AuthShell, { StepRail, go } from "./auth/AuthShell";

/**
 * Where in setting a shop up each hand-off point sits.
 *
 * Sign-in decides what still has to happen and leaves it in
 * `nextStep`; this turns that into a position on the rail.
 */
const STEP_FOR_NEXT = {
  "/addShop": 1,
  "/api/v1/paymentMethod": 1,
  "/shopAdmin/dashboard": 2,
};

const COPY = {
  "/addShop": {
    title: "Let us set your shop up",
    subtitle: "Tell us what you sell, where you are and how you deliver.",
    action: "Add my shop",
  },
  "/api/v1/paymentMethod": {
    title: "One thing left",
    subtitle: "Add the account we should pay your earnings into.",
    action: "Add payment details",
  },
  "/shopAdmin/dashboard": {
    title: "Your shop is being reviewed",
    subtitle: "We check every new shop before it goes live. This usually takes a day.",
    action: "Go to my dashboard",
  },
};

/**
 * Rules - the signpost between signing in and whatever is still owed.
 *
 * It is the only screen a half-finished shop sees, so rather than the
 * same four static bullets for everyone it says which stage the shop
 * is actually at and what the button will do.
 */
const Rules = (props) => {
  const history = props.history;
  const nextStep = window.localStorage.getItem("nextStep");

  // Nothing to continue to means the session was cleared or the page
  // was opened directly; the old version navigated to `endPoint + null`.
  if (!nextStep || !COPY[nextStep]) {
    return (
      <AuthShell
        title="Nothing to continue"
        subtitle="Sign in again to pick up where you left off."
        brandText="Menus, orders, promotions, deliveries and payouts, in one place."
      >
        <div className="authForm">
          <Button variant="primary" size="lg" block onClick={() => go(history, "/login")}>
            Go to sign in
          </Button>
        </div>
      </AuthShell>
    );
  }

  const copy = COPY[nextStep];
  const current = STEP_FOR_NEXT[nextStep];

  return (
    <AuthShell
      title={copy.title}
      subtitle={copy.subtitle}
      brandTitle="Run your shop on Spark"
      brandText="Menus, orders, promotions, deliveries and payouts, in one place."
    >
      <div className="authForm">
        {current === 2 && (
          <div className="dsFormMessage info" role="status">
            <HourglassEmptyIcon />
            <span>
              You can look around the panel while you wait. Orders start arriving once your shop
              is approved.
            </span>
          </div>
        )}

        <StepRail current={current} onSurface />

        <Button variant="primary" size="lg" block onClick={() => go(history, nextStep)}>
          {copy.action}
        </Button>
      </div>
    </AuthShell>
  );
};

export default Rules;
